// U-TOPIA official logo (white), uses the brand asset provided by the client.

export const LogoMark = ({ size = 36, className = "" }) => (
  <img
    src="/utopia-mark-white.png"
    alt="U-TOPIA mark"
    width={size}
    height={size}
    className={className}
    style={{ height: size, width: size, objectFit: "contain" }}
  />
);

export const Logo = ({ size = 34, className = "" }) => (
  <img
    src="/utopia-logo-white.png"
    alt="u-topia"
    className={`select-none ${className}`}
    style={{ height: size, width: "auto", objectFit: "contain" }}
  />
);

export default Logo;
